import { render } from "./LanguageSwitch.vue?vue&type=template&id=296c44eb&scoped=true"
import script from "./LanguageSwitch.vue?vue&type=script&lang=js"
export * from "./LanguageSwitch.vue?vue&type=script&lang=js"

import "./LanguageSwitch.vue?vue&type=style&index=0&id=296c44eb&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ft\\Coding\\GT Designer\\gtdesigner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296c44eb"]])

export default __exports__